module.exports = __webpack_public_path__ + "img/62a0a35.png";